import React from 'react';
import AssessmentIcon from '@material-ui/icons/Assessment';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  statusLabel: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const ProjectStatusLabel = ({ status }) => {
  const theme = useTheme();
  const classes = useStyles();

  const PROJECT_STATUS = [
    'Do głosowania',
    'Odrzucony',
    'Wybrany do realizacji',
    'Niewybrany do realizacji',
    'Odrzucony formalnie',
    'Oceniony pozytywnie',
    'Ocena pozytywna',
    'Ocena negatywna',
    'Złożony',
  ];

  switch (status) {
    case PROJECT_STATUS[0]:
    case PROJECT_STATUS[5]:
    case PROJECT_STATUS[6]:
    case PROJECT_STATUS[8]: {
      return (
        <span
          className={classes.statusLabel}
          style={{ color: theme.palette.warning.dark }}
        >
          <AssessmentIcon />
          {status}
        </span>
      );
    }
    case PROJECT_STATUS[4]:
    case PROJECT_STATUS[1]:
    case PROJECT_STATUS[7]: {
      return (
        <span
          className={classes.statusLabel}
          style={{ color: theme.palette.error.dark }}
        >
          <HighlightOffIcon />
          {status === 'Odrzucony formalnie' ? 'Odrzucony' : status}
        </span>
      );
    }
    case PROJECT_STATUS[2]: {
      return (
        <span
          className={classes.statusLabel}
          style={{ color: theme.palette.success.dark }}
        >
          <StarIcon />
          {status}
        </span>
      );
    }
    case PROJECT_STATUS[3]: {
      return (
        <span
          className={classes.statusLabel}
          style={{ color: theme.palette.statusLabel.dark }}
        >
          <StarBorderIcon />
          {status}
        </span>
      );
    }
    default: {
      return null;
    }
  }
};

export default ProjectStatusLabel;
